import { getPerfis } from '@/services/auth.js';

export const PERFIS_INTERNOS = [
    'ADMIN_TI',
    'CONSELHO_ADMINISTRACAO',
    'COMISSAO_SELECAO',
    'RELACIONAMENTO_COOPERADOS',
    'COMPLIANCE',
];

export function perfisDaRota(rota) {
    if (!rota || !rota.matched) return [];
    return rota.matched.reduce((acumulado, registro) => {
        if (registro.meta && registro.meta.perfis) return acumulado.concat(registro.meta.perfis);
        return acumulado;
    }, []);
}

export function temAcessoARota(rota) {
    const exigidos = perfisDaRota(rota);
    if (exigidos.length === 0) return true;
    // Ãrea restrita: todos os perfis internos acessam as telas; sÃ³ UsuÃ¡rios exige ADMIN_TI.
    if (exigidos.length === 1 && exigidos[0] === 'ADMIN_TI') {
        return getPerfis().includes('ADMIN_TI');
    }
    if (exigidos.some((perfil) => PERFIS_INTERNOS.includes(perfil))) {
        return ehInterno();
    }
    return getPerfis().some((perfil) => exigidos.includes(perfil));
}

export function ehCandidato() {
    return getPerfis().includes('CANDIDATO');
}

export function ehInterno() {
    return getPerfis().some((perfil) => PERFIS_INTERNOS.includes(perfil));
}

// EtapaInscricao do backend â onde o candidato retoma. Da etapa 5 em diante (curso,
// certificado, habilitaÃ§Ã£o) nÃ£o hÃ¡ aÃ§Ã£o dele na jornada, sÃ³ acompanhamento.
export const ROTA_POR_ETAPA_PROCESSO = {
    1: 'inscricao-dados-pessoais',
    2: 'inscricao-documentos',
    3: 'candidato-acompanhamento',
    4: 'inscricao-pagamento',
};

export const PRIMEIRA_ETAPA_SEM_ACAO_DO_CANDIDATO = 5;

export function rotaInicialDoUsuario({
    temEdital = false, temInscricao = false, aceitouTermos = false, etapaProcesso = null,
} = {}) {
    if (ehCandidato()) {
        if (!temEdital) return 'candidato-edital';
        if (!temInscricao) return 'inscricao-especialidade';
        if (!aceitouTermos) return 'candidato-termos';
        if (ROTA_POR_ETAPA_PROCESSO[etapaProcesso]) return ROTA_POR_ETAPA_PROCESSO[etapaProcesso];
        return etapaProcesso >= PRIMEIRA_ETAPA_SEM_ACAO_DO_CANDIDATO
            ? 'candidato-acompanhamento'
            : 'inscricao-dados-pessoais';
    }
    if (ehInterno()) return 'inscricoes';
    return 'login';
}
